class FaqShipping extends HTMLElement {
    constructor() {
        super();

        this.config = window.config?.faq_shipping;

        if (!this.config || !this.config.blocks) {
            console.error('info not found');
            this.innerHTML = `<p>Shipping info NA.</p>`;
            return;
        }

        this.notice = this.config.settings.notice || '';
        
    }

    connectedCallback(){
        this.render();

    }

    render() {
        const countries = this.config.blocks
            .map(block => block?.country)
            .filter(country => country);

        const uniqueCountries = [...new Set(countries)];

        if (uniqueCountries.length === 0) {
            console.error('No valid countries found');
            this.innerHTML = `<p>No shipping information available</p>`;
            return;
        }

        this.innerHTML = `
            <div class="faq_shipping" style="text-align:left;">
             <label for="country-select" id="country-select-label">Select a Country:</label>
                <select id="country-select" name="country" aria-labelledby="country-select-label"
                    style="
                    all: unset;
                    appearance: none;
                    background: #FEEDF1;
                    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23131313%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
                    background-repeat: no-repeat;
                    background-position: right 0.7rem top 50%;
                    background-size: 0.65rem auto;
                    width: 90%;
                    padding: 5px 7.5px;
                    border-radius: 5px;
                ">
                    <option value="" disabled selected>Select a country</option>
                    ${uniqueCountries.map(country => `<option value="${country}">${country}</option>`).join('')}
                </select>
                <div id="shipping-info"></div>
            </div>
            ${this.notice ? `<div id="notice" style="
                margin-top: 20px; 
                background-color: #ffdcf2; 
                border-radius: 8px; 
                padding: 15px; 
                color: #000;">${this.notice}</div>` : ''}
        `;
        this.querySelector('#country-select').addEventListener('change', (event) => {
            this.updateShippingInfo(event.target.value);
        });
    }

    updateShippingInfo(selectedCountry) {
        const countryBlock = this.config.blocks.find(block => block?.country === selectedCountry);
        if (!countryBlock) {
            this.querySelector('#shipping-info').innerHTML = `<p>No information available for ${selectedCountry}.</p>`;
            return;
        }

        const shippingInfoHTML = `
            <table style="width: 100%; border-collapse: collapse; margin: 20px 0;">
                <thead>
                    <tr style="border-bottom: 1px solid var(--wf_warm_pink) ;">
                        <th style="text-align:left; width: 33%; font-weight:600; text-transform:uppercase; padding: 5px;">Shipped By</th>
                        <th style="text-align:left; width: 33%; font-weight:600; text-transform:uppercase; padding: 5px;">Delivery Time</th>
                        <th style="text-align:left; width: 33%; font-weight:600; text-transform:uppercase; padding: 5px;">Price</th>
                    </tr>
                </thead>
                <tbody>
                    ${[1, 2, 3, 4, 5, 6].map(i => {
                        const courier = countryBlock[`courier-${i}`];
                        const eta = countryBlock[`eta-${i}`];
                        const price = countryBlock[`price-${i}`];

                        return courier || eta || price
                            ? `<tr style="border-bottom: 1px solid var(--wf_warm_pink) ;">
                                    <td style="padding: 10px;">${courier || 'N/A'}</td>
                                    <td style="padding: 10px;">${eta || 'N/A'}</td>
                                    <td style="padding: 10px;">${price || 'N/A'}</td>
                            </tr>`
                            : '';
                    }).join('')}
                </tbody>
            </table>
               ${countryBlock.country_notice ? `<div style="
                margin-top: 20px; 
                background-color: #ffdcf2; 
                border-radius: 8px; 
                padding: 15px; 
                color: #000;">${countryBlock.country_notice}</div>` : ''}
            <div>${countryBlock.additional_information || ''}</div>
        `;

        this.querySelector('#shipping-info').innerHTML = shippingInfoHTML;
    }
}

customElements.define('faq-shipping', FaqShipping);

